document.addEventListener('DOMContentLoaded', function () {
    // Check if the body has the class "template--pdp-v2"
    if (document.body.classList.contains('template--pdp-v2') || document.body.classList.contains('template--merch-v2')) {

        const quantityDiv = document.querySelector('.product-form__quantity-v1');

        if (quantityDiv) {
            quantityDiv.remove();
            console.log('.product-form__quantity-v1 has been removed from the DOM.');
        }

        const monitorPriceChanges = () => {
            // Select the target nodes to observe
            const priceNode = document.querySelector('.subscribe-and-save-price');
            const discountNode = document.querySelector('.subscribe-and-save');

            if (!priceNode && !discountNode) {
                console.error('Target nodes not found: .subscribe-and-save-price or .subscribe-and-save');
                return;
            }

            // Elements to update
            const regularPriceElement = document.querySelector('.regular-price span');
            const savePercentageElement = document.querySelector('.save-percentage span');
            const subscribePriceElement = document.querySelector('.subscribe-price');

            let lastRegularPrice = null;
            let lastSalePrice = null;
            let lastPercentageOff = null;

            // Function to load default values
            const loadDefaultValues = () => {
                if (priceNode) {
                    const regularPrice = priceNode.querySelector('.text-primary')?.textContent.trim();
                    const salePrice = priceNode.querySelector('.text-primaryRed')?.textContent.trim();

                    if (regularPrice) {
                        lastRegularPrice = regularPrice;
                        if (regularPriceElement) regularPriceElement.textContent = regularPrice;
                    }

                    if (salePrice) {
                        lastSalePrice = salePrice;
                        if (subscribePriceElement) subscribePriceElement.textContent = salePrice;
                    }
                }

                if (discountNode) {
                    const percentageOffRaw = discountNode?.textContent.trim();
                    const percentageOff = percentageOffRaw ? percentageOffRaw.replace('Subscribe & Save ', '').trim() : null;

                    if (percentageOff) {
                        lastPercentageOff = percentageOff;
                        if (savePercentageElement) savePercentageElement.textContent = percentageOff;
                    }
                }
            };

            // Callback function for when mutations are observed
            const mutationCallback = (mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        // Monitor regular and sale price
                        if (priceNode) {
                            const regularPrice = priceNode.querySelector('.text-primary')?.textContent.trim();
                            if (regularPrice && regularPrice !== lastRegularPrice) {
                                // console.log('Regular price changed:', regularPrice); // Uncomment for debugging
                                lastRegularPrice = regularPrice;
                                if (regularPriceElement) regularPriceElement.textContent = regularPrice;
                            }

                            const salePrice = priceNode.querySelector('.text-primaryRed')?.textContent.trim();
                            if (salePrice && salePrice !== lastSalePrice) {
                                // console.log('Sale price changed:', salePrice); // Uncomment for debugging
                                lastSalePrice = salePrice;
                                if (subscribePriceElement) subscribePriceElement.textContent = salePrice;
                            }
                        }

                        // Monitor percentage off
                        if (discountNode) {
                            const percentageOffRaw = discountNode?.textContent.trim();
                            if (percentageOffRaw) {
                                const percentageOff = percentageOffRaw.replace('Subscribe & Save ', '').trim();
                                if (percentageOff && percentageOff !== lastPercentageOff) {
                                    console.log('Percentage off changed:', percentageOff);
                                    lastPercentageOff = percentageOff;
                                    if (savePercentageElement) savePercentageElement.textContent = percentageOff;
                                }
                            }
                        }
                    }
                });
            };

            // Create a MutationObserver instance
            const observer = new MutationObserver(mutationCallback);

            // Start observing the target nodes for changes
            if (priceNode) {
                observer.observe(priceNode, {
                    childList: true, // Observe direct child elements
                    subtree: true,   // Observe all descendants
                    characterData: true, // Observe changes to text content
                });
            }

            if (discountNode) {
                observer.observe(discountNode, {
                    childList: true, // Observe direct child elements
                    subtree: true,   // Observe all descendants
                    characterData: true, // Observe changes to text content
                });
            }

            console.log('Started monitoring .subscribe-and-save-price and .subscribe-and-save for changes.');

            // Load default values on page load
            loadDefaultValues();
        };

        // Call the function to start monitoring
        monitorPriceChanges();

        // Updates the nutrition image based on the selected flavor or serving size

        // Parse the JSON data from the script tag
        const variantNutritionData = document.querySelector(".variant-nutrition-facts") ? JSON.parse(
            document.querySelector(".variant-nutrition-facts").textContent
        ) : null

        // Function to get the selected value from the Flavor fieldset
        function getSelectedFlavor() {
            const selectedFlavorInput = document.querySelector(
                "fieldset#Flavor input:checked"
            );
            return selectedFlavorInput ? selectedFlavorInput.value : null;
        }

        // Function to get the selected value from the Serving Size dropdown
        function getSelectedServingSize() {
            const servingSizeDropdown = document.querySelector(
                "select#Serving\\ Size" // Escaping space in the ID
            );
            return servingSizeDropdown ? servingSizeDropdown.value : null;
        }

        // Function to find the matching variant based on selected options
        function findMatchingVariant(selectedFlavor, selectedServingSize) {
            if (!variantNutritionData) {
                return null
            }
            return variantNutritionData.find((variant) => {
                const variantTitle = variant.variant_title.toLowerCase();
                if (selectedFlavor && selectedServingSize) {
                    return (
                        variantTitle.includes(selectedFlavor.toLowerCase()) &&
                        variantTitle.includes(selectedServingSize.toLowerCase())
                    );
                } else if (selectedServingSize) {
                    return variantTitle.includes(selectedServingSize.toLowerCase());
                }
                return false;
            });
        }

        // Function to find the matching variant based on selected flavor only
        function findMatchingFlavorOnly(selectedFlavor) {
            if (!variantNutritionData) {
                return null
            }
            return variantNutritionData.find((variant) => {
                const variantTitle = variant.variant_title.toLowerCase();
                if (selectedFlavor) {
                    return (
                        variantTitle.includes(selectedFlavor.toLowerCase())
                    );
                }
                return false;
            });
        }

        // Function to update the nutrition image
        function updateNutritionImage() {
            const selectedFlavor = getSelectedFlavor();
            const selectedServingSize = getSelectedServingSize();

            // Find the matching variant
            const matchingVariant = findMatchingVariant(selectedFlavor, selectedServingSize);
            const matchingFlavor = findMatchingFlavorOnly(selectedFlavor);

            // Update the #nutrition-content > img src
            const nutritionImage = document.querySelector("#nutrition-content > img");


            if (!nutritionImage) {
                return;
            }

            if (matchingVariant && matchingVariant.nutrition_facts_image_src) {
                nutritionImage.src = matchingVariant.nutrition_facts_image_src;
            }
            if (matchingFlavor && matchingFlavor.nutrition_facts_image_src) {
                nutritionImage.src = matchingFlavor.nutrition_facts_image_src;
            }
        }

        // Event listener for the Flavor radio buttons
        const flavorFieldset = document.querySelector("fieldset#Flavor");
        if (flavorFieldset) {
            flavorFieldset.addEventListener("change", updateNutritionImage);
        } else {
            console.warn("Flavor fieldset not found.");
        }

        // Event listener for the Serving Size dropdown
        const servingSizeDropdown = document.querySelector("select#Serving\\ Size");
        if (servingSizeDropdown) {
            servingSizeDropdown.addEventListener("change", updateNutritionImage);
        } else {
            console.warn("Serving Size dropdown not found.");
        }

        // Initial load: Check if the elements exist before calling the function
        if (flavorFieldset || servingSizeDropdown) {
            updateNutritionImage();
        } else {
            console.warn("One or more elements not found. Nutrition image not updated.");
        }


        // Initial load
        updateNutritionImage();


        if (window.innerWidth < 1024 && document.querySelector('.product-form__buttons')) {
            const container = document.querySelector('.product-qty-atc-container');
            const element = document.querySelector('.product-form__buttons');

            const observer = new IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    element.classList.remove('atc-stick');
                } else {
                    element.classList.add('atc-stick');
                }
            }, {threshold: 0});

            observer.observe(container);
        }
    }
    // Accordion functionality for PDP
    document.querySelectorAll('.accordion-trigger').forEach(trigger => {
        trigger.addEventListener('click', function (event) {
            const accordionItem = this.closest('.accordion-item');  // Get the parent .accordion-item

            // Log to check if parent has .accordion-faq
            // console.log('accordionItem:', accordionItem);
            // console.log('Has accordion-faq:', accordionItem.classList.contains('accordion-faq'));

            // Check if the parent .accordion-item has the class 'accordion-faq'
            if (accordionItem.classList.contains('accordion-faq')) {
                console.log('Skipping scroll due to accordion-faq class');
                return;
            }

            // event.preventDefault();

            const content = accordionItem.querySelector('.accordion-content');

            // Toggle the accordion item open or closed
            const isOpen = accordionItem.classList.contains('open');
            accordionItem.classList.toggle('open');

            // Update ARIA attributes for accessibility
            this.setAttribute('aria-expanded', !isOpen);

            if (content) {
                content.hidden = isOpen;
            }

            // Scroll to the accordion-trigger with an offset for the sticky navigation
            const offset = 120; // Adjust this value based on the height of your sticky navigation
            const triggerPosition = this.getBoundingClientRect().top + window.scrollY - offset;

            setTimeout(() => {
                window.scrollTo({
                    top: triggerPosition,
                    behavior: 'smooth',
                });
            }, 300);
        });
    });
});